<template>
    <div>
        <h3 class="title_header">权限管理</h3>
        <div class="from_header">
            <div class="filterText">
                <el-button type="primary" round @click="showAddDialog(0)">添加权限</el-button>
            </div>
            <el-tree
                    :data="data"
                    node-key="pid"
                    :default-expand-all="true"
                    :highlight-current="true"
                    :expand-on-click-node="false" style="height: 700px;overflow-y: auto">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div style="width: 400px;float: left;text-align: left;">{{ data.powerName }}</div>
                <div style="width:400px;text-align: right;margin-left: 400px;">
                  <el-button
                          type="text"
                          size="mini"
                          @click="() => showAddDialog(data.pid)">
                    添加
                  </el-button>
                  <el-button
                          type="text"
                          size="mini"
                          @click="() => showUpdateDialog(data)">
                    修改
                  </el-button>
                  <el-button
                          type="text"
                          size="mini"
                          @click="() => showDelete( data)">
                    删除
                  </el-button>
                </div>
              </span>
            </el-tree>
        </div>


        <el-dialog :title="isAdd?'添加权限':'修改权限'" :visible.sync="dialogFormVisible" width="600px"
                   :close-on-click-modal="false">
            <el-form :model="formData">
                <el-form-item label="权限名称：" label-width="100px">
                    <el-input v-model="formData.powerName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="权限url：" label-width="100px">
                    <el-input v-model="formData.authkey" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="权限图标：" label-width="100px" v-if="formData.powerType == 1">
                    <el-input v-model="formData.powerIcon" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="排序：" label-width="100px">
                    <el-input v-model="formData.orderNum" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item label="权限类型：" label-width="100px">
                    <el-radio v-model="formData.powerType" :label="1">菜单权限</el-radio>
                    <el-radio v-model="formData.powerType" :label="2">请求权限</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addPower" v-if="isAdd">确 定</el-button>
                <el-button type="primary" @click="updatePower" v-else>确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    export default {
        name: "powerList",
        data() {
            return {
                data: [{
                    "authkey": "",
                    "children": [],
                    "pid": 0,
                    "powerIcon": "",
                    "powerName": "",
                    "powerType": 0
                }],
                dialogFormVisible: false,//是否打开弹窗
                isAdd: true,// 是否是添加：true = 添加  false = 修改
                formData: {
                    authkey: "",
                    parentId: 0,
                    powerIcon: "",
                    powerName: "",
                    powerType: 1,
                    orderNum: 0,
                }
            };
        },

        methods: {
            dataList() {
                this.$post(this.$url.权限列表, {})
                    .then(resp => {
                        this.data = resp;
                    }).catch(() => {
                    this.data = [];
                });
            },
            addPower() {
                this.$post(this.$url.权限添加, this.formData)
                    .then(resp => {
                        //清除弹窗内容
                        this.clearDialogDate();
                        //获取最新权限信息
                        this.dataList();
                        //关闭弹窗
                        this.dialogFormVisible = false;
                    }).catch(() => {
                    //关闭弹窗
                    this.dialogFormVisible = false;
                });
            },
            updatePower() {
                this.$post(this.$url.权限修改, this.formData)
                    .then(resp => {
                        //清除弹窗内容
                        this.clearDialogDate();
                        //获取最新权限信息
                        this.dataList();
                        //关闭弹窗
                        this.dialogFormVisible = false;
                    }).catch(() => {
                    //关闭弹窗
                    this.dialogFormVisible = false;
                });
            },
            deletePower(pid) {
                this.$post(this.$url.权限删除, {pid: pid})
                    .then(resp => {
                        //获取最新权限信息
                        this.dataList();
                    }).catch(() => {
                });
            },
            /**
             * 打开添加弹窗
             * @param pid 父节点ID
             */
            showAddDialog(pid) {
                if (!this.isAdd) {
                    this.isAdd = true;
                    this.clearDialogDate();
                }
                this.formData.parentId = pid;
                this.dialogFormVisible = true;
            },
            /**
             * 打开修改弹窗
             * @param pid 父节点ID
             */
            showUpdateDialog(data) {
                if (this.isAdd) {
                    this.isAdd = false;
                    this.clearDialogDate();
                }
                this.formData.pid = data.pid;
                this.formData.authkey = data.authkey;
                this.formData.powerIcon = data.powerIcon;
                this.formData.powerName = data.powerName;
                this.formData.powerType = data.powerType;
                this.formData.orderNum = data.orderNum;

                this.dialogFormVisible = true;

            },
            showDelete(data) {
                this.$confirm('是否删除【' + data.powerName + "】权限", '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '返回'
                })
                    .then(() => {
                        this.deletePower(data.pid);
                    })
                    .catch(action => {
                    });
            },
            /**
             * 清除Dialog窗口数据
             */
            clearDialogDate() {
                this.formData = {
                    authkey: "",
                    parentId: 0, //添加时才有的属性
                    pid: 0,//修改时才有的属性
                    powerIcon: "",
                    powerName: "",
                    powerType: 1,
                    orderNum: 0
                }
            }

        },
        mounted() {
            this.dataList();
        }
    };
</script>


<style scoped lang="less">

    .title_header {
        text-align: left;
        padding: 20px 20px 10px 20px;
        background-color: #ffffff;
        margin-bottom: 3px;
    }
    .from_header {
        background-color: #ffffff;
        padding: 15px 0 2px 0;
        margin-bottom: 3px;

        .filterText {
            text-align: left;
            padding: 10px 0 10px 10px;
            background-color: #FFFFFF;
        }
    }


    .addOrUpdate {
        width: 40%;
        float: left;
    }

</style>
